import { HttpResult } from "widgets-for-react"
import { SimpelPage } from "../../../../utils"
import { Webinar, TaxonomyResponse } from "./webinars.types"

interface WordPressRequestParams {
  page?: number
  per_page?: number
  _embed?: number
  brochures_taxonomy?: number
  country_taxonomy?: number | string
}

export const get_paginated_webinars = async (lang: string, params: WordPressRequestParams): Promise<HttpResult<SimpelPage<Webinar>>> => {
  if (lang != "" && !lang.startsWith("/")) {
    lang = "/" + lang
  }

  const searchParams = new URLSearchParams()

  // Country can also be a string for the static terms
  // Do not send this to the WP API
  if (params.country_taxonomy && typeof params.country_taxonomy == 'number') {
    searchParams.append('country_taxonomy', `${params.country_taxonomy}`)
  }

  if (params.brochures_taxonomy && typeof params.brochures_taxonomy == 'number') {
    searchParams.append('brochures_taxonomy', `${params.brochures_taxonomy}`)
  }

  if (params.page) {
    searchParams.append('page', `${params.page}`)
  }

  if (params.per_page) {
    searchParams.append('per_page', `${params.per_page}`)
  }

  if (params._embed) {
    searchParams.append('_embed', `${params._embed}`)
  }

  let response = await fetch(`${lang}/wp-json/wp/v2/webinars?${searchParams}`)
  if (!response.ok) return ({ kind: 'failed', status: response.status })

  let body = await response.json()

  let current_page = params.page || 1
  let size = params.per_page || 10
  let total_pages = Number(response.headers.get('x-wp-totalpages'))
  let total_items = Number(response.headers.get('x-wp-total'))

  return ({
    kind: 'result', status: response.status, value: ({
      current_page: current_page,
      items: body,
      page_size: size,
      total_pages: total_pages,
      total_items: total_items
    })
  })

}


export const get_taxonomies = async (term: string, lang: string): Promise<HttpResult<TaxonomyResponse[]>> => {
  if (lang != "" && !lang.startsWith("/")) {
    lang = "/" + lang
  }
  let response = await fetch(`${lang}/wp-json/wp/v2/${term}/?per_page=99`)
  if (!response.ok) return ({ kind: 'failed', status: response.status })

  let body = await response.json()

  return ({ kind: 'result', status: response.status, value: body })
}